import PropTypes from "prop-types";
import BankAccountSourcePrioritySetting from "./BankAccountSourcePrioritySetting.jsx";
import CustomerObjectRefNumLabelSetting from "./CustomerObjectRefNumLabelSetting.jsx";

/**
 * Inhalt des "Einstellungen"-Tabs der Kundendetailseite - bündelt die
 * einzelnen Kundeneinstellungen, die aktuell alle dieselbe Berechtigung
 * (CustomerPolicy::update(), KundeResource::can_update) voraussetzen.
 */
export default function CustomerSettingsPanel({ customerId, customer, onUpdate }) {
  return (
    <>
      <BankAccountSourcePrioritySetting
        customerId={customerId}
        priority={customer.bank_account_source_priority}
        onUpdate={onUpdate}
      />
      <CustomerObjectRefNumLabelSetting
        customerId={customerId}
        label={customer.object_ref_num_label}
        onUpdate={onUpdate}
      />
    </>
  );
}

CustomerSettingsPanel.propTypes = {
  customerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  customer: PropTypes.shape({
    bank_account_source_priority: PropTypes.array,
    object_ref_num_label: PropTypes.string,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
};
